// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2M9rE","content":"Consent_content__aRz79","footer":"Consent_footer__1Tu3d"};